// OptionsContext.js
import React, { createContext, useContext, useState } from 'react';

export const OptionsContext = createContext();

export function OptionsProvider({ children }) {
  const [options, setOptions] = useState({});
  return (
    <OptionsContext.Provider value={{ options, setOptions }}>
      {children}
    </OptionsContext.Provider>
  );
}

export const useOptions = () => useContext(OptionsContext);